/**
 * InfoBox - Bloque de mensaje informativo
 * Caja con bordes redondeados, sin borde, fondo violeta muy claro
 */

import { Node, mergeAttributes } from '@tiptap/core';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    infoBox: {
      insertInfoBox: () => ReturnType;
    };
  }
}

export const InfoBox = Node.create({
  name: 'infoBox',
  group: 'block',
  content: 'block+',
  defining: true,

  parseHTML() {
    return [{ tag: 'div[data-type="info-box"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'info-box',
        class: 'info-box',
      }),
      0,
    ];
  },

  addCommands() {
    return {
      insertInfoBox:
        () =>
        ({ chain }) => {
          return chain()
            .focus()
            .insertContent({
              type: this.name,
              content: [{ type: 'paragraph', content: [] }],
            })
            .run();
        },
    };
  },
});
